import moment from 'moment'
import axios from 'axios'
import {mapState} from 'vuex'

const state = {
  project: {},
  user: {}
}

const getters = {
  project: state => state.project,
  user: state => state.user
}


const mutations = {
  setCurrentUser: (state , payload) => { state.user = payload },
  setCurrentProject: (state , payload) => { state.project = payload },
}


const actions = {

}



export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/current.js